import {Tooltip} from 'bootstrap';

export default class BootstrapTooltip {
    public constructor(element: Element) {
        // tslint:disable-next-line:no-unused-expression
        new Tooltip(element as HTMLElement);
    }
}
